module.exports = __webpack_public_path__ + "img/local_grocery_store.af7b9e75.svg";